import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans } from '@lingui/macro'
import { WeeklyConsultations } from './charts/WeeklyConsultations'
import { WeeklyPatients } from './charts/WeeklyPatients'
import { ConsultationTypes } from './charts/ConsultationTypes'
import { ConsultationStatuses } from './charts/ConsultationStatuses'

type OverviewSectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  establishmentId: string
  isMobile: boolean
}

export function OverviewSection({ isExpanded, onChange, establishmentId, isMobile }: OverviewSectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      slotProps={{
        transition: { unmountOnExit: false, mountOnEnter: true },
      }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="overview-content" id="overview-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>Overview</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <WeeklyConsultations establishmentId={establishmentId} />
          </Grid>
          <Grid item xs={12}>
            <WeeklyPatients establishmentId={establishmentId} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ConsultationTypes establishmentId={establishmentId} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ConsultationStatuses establishmentId={establishmentId} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
